// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv[data-v-fb5a7f36] {\n  /** todo: properly scope event-logic.scss and remove */\n  margin-top: 0 !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
